import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalFormService } from "./modal-form.service";
import { ModalModule } from "ngx-bootstrap";

@NgModule({
  imports: [CommonModule, ModalModule.forRoot()],
  providers: [ModalFormService]
})
export class ModalFormModule {
  static forRoot(providers?: any[]): ModuleWithProviders {
    return {
      ngModule: ModalFormModule,
      providers: providers
    };
  }
}
